<template>
  <div class="animated fadeIn">
    <Forms ref="frmAssunto"
      :title="'CADASTRO DE USUÁRIO TOTEM'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-if="form.nome.required" class="text-danger">*</small> Nome:</label>
          <b-form-input type="text" :placeholder="'Digite o Nome da Mesa'"
                        v-model="form.nome.value"
                        :size="form.nome.maxlength"
                        :required="form.nome.required"
                        :state="form.nome.state"></b-form-input>
        </div>
        <div class="col-md-12">
          <label><small v-if="form.username.required" class="text-danger">*</small> Username:</label>
          <b-form-input type="text" :placeholder="'Digite o Username'"
                        v-model="form.username.value"
                        :size="form.username.maxlength"
                        :required="form.username.required"
                        :state="form.username.state"></b-form-input>
        </div>
      </div>

      <NxSelectPA
        :multiple="false"
        v-model="form.paId.value"
        @update:value="handleSelectUpdate('paId', $event)"
      />

      <div class="col-md-12">
        <NxSelectNxSenhasMesa
          :multiple="true"
          @update:value="handleSelectUpdate('mesasIds', $event)"
          v-model="form.mesasIds.value"
        />
      </div>

      <div class="form-group">
        <h5 class="text-third"><i class="fa fa-lock"></i> {{ $lang.Accounts.AccessPasswords }}</h5>
        <div class="row">
          <div class="col-md-6">
            <label for="txtPassword">{{ $lang.Accounts.LabelPassword }}:</label>
            <b-form-input type="password" :placeholder="$lang.Accounts.PlaceholderEnterPassword"
                          v-model="form.password.value" :size="form.password.maxlength"
                          :required="form.password.required" :state="form.password.state"
                          autocomplete="new-password" @input="validatePassword"></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group">
        <small class="text-third"><i class="fa fa-info-circle"></i>
          {{ $lang.Accounts.PasswordOnlyNewRegistration }}</small>
      </div>

      <hr>
      <span style="font-weight: 700">Requisitos Mínimos:</span>
      <ul>
        <li :class="lengthValid ? 'text-success' : 'text-danger'">Comprimento mínimo de 8 caracteres</li>
        <li :class="uppercaseValid ? 'text-success' : 'text-danger'">Letra maiúscula</li>
        <li :class="lowercaseValid ? 'text-success' : 'text-danger'">Letra minúscula</li>
        <li :class="numberValid ? 'text-success' : 'text-danger'">Número (1 - 9)</li>
        <li :class="specialCharValid ? 'text-success' : 'text-danger'">Caractere especial (!@#$%&*()+-)</li>
      </ul>

    </Forms>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import TotemModel from '@/shared/models/configurations/totemmodel.js'
import { NxSelectPA } from '@/components/nexum/components/custom-selects/index.js'
import TotemForms from './totem-form.js'
import UserRepository from '@/shared/http/repositories/nxSenhas/usuario.js'
import NxSelectNxSenhasMesa from '@/components/nexum/components/custom-selects/NxSelectNxSenhasMesa.vue'

export default {
  name: 'TotemAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: TotemModel,
      form: TotemForms
    }
  },
  components: {
    NxSelectNxSenhasMesa,
    NxSelectPA
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()

      this.form.nome.value = obj.nome || ''
      this.form.username.value = obj.username || ''
      this.form.paId.value = obj.pa
        ? { id: obj.pa.id, text: obj.pa.descricao }
        : null
      this.form.tipoUsuario.value = 'USUARIO_TOTEM'

      this.form.mesasIds.value = (obj.mesas || []).map(mesa => ({
        value: mesa.id,
        text: mesa.nome
      }))

      this.data = { ...this.data, ...obj }

      loading.pop()
    },
    onCreate () {
      loading.push()

      const midias = []

      const mesasIds = Array.isArray(this.form.mesasIds.value)
        ? this.form.mesasIds.value.map(item => item.value)
        : []

      const paId = this.form.paId.value
        ? (typeof this.form.paId.value === 'object'
          ? this.form.paId.value.id
          : this.form.paId.value)
        : null

      const dataToSend = {
        ...this.data,
        tipoUsuario: 'USUARIO_TOTEM',
        mesasIds,
        midias,
        paId // sobrescreve para garantir que é só o id
      }

      UserRepository.Create(dataToSend)
        .then(() => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()

      const midias = []

      const paId = this.form.paId.value
        ? (typeof this.form.paId.value === 'object'
          ? this.form.paId.value.id
          : this.form.paId.value)
        : null

      const dataToSend = {
        ...this.data,
        id: parseInt(this.data.id),
        tipoUsuario: 'USUARIO_TOTEM',
        mesasIds: this.form.mesasIds.value.map(item => item.value),
        midias,
        paId // sobrescreve para garantir que é só o id
      }

      UserRepository.Update(dataToSend, dataToSend.id)
        .then(() => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },

    handleSelectUpdate (fieldName, selectedValue) {
      if (fieldName === 'paId') {
        // Sempre mantenha apenas o id em this.data
        this.data[fieldName] = selectedValue && typeof selectedValue === 'object'
          ? selectedValue.id
          : selectedValue
        this.form[fieldName].value = selectedValue
      } else if (Array.isArray(selectedValue)) {
        const ids = selectedValue.map(item => item.value)
        this.data[fieldName] = ids
        this.form[fieldName].value = selectedValue
      } else if (selectedValue && typeof selectedValue === 'object' && 'value' in selectedValue) {
        this.data[fieldName] = selectedValue.value
        this.form[fieldName].value = selectedValue
      } else {
        this.data[fieldName] = Array.isArray(this.form[fieldName].value) ? [] : null
        this.form[fieldName].value = selectedValue
      }
    },
    validatePassword (password) {
      this.lengthValid = password.length >= 8
      this.uppercaseValid = /[A-Z]/.test(password)
      this.lowercaseValid = /[a-z]/.test(password)
      this.numberValid = /\d/.test(password)
      this.specialCharValid = /[!@#$%&*()+-]/.test(password)
    },
    resetPasswordFields () {
      this.form.confirmation.value = ''
      this.form.password.value = ''
      this.lengthValid = false
      this.uppercaseValid = false
      this.lowercaseValid = false
      this.numberValid = false
      this.specialCharValid = false
    }

  },
  onException (error) {
    loading.close()
    toast.error(
      error.response.data.message ||
      error.message ||
      'Erro ao salvar usuário'
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/totem/components/add/totemAdd.vue